export const FETCH = 'app/data/FETCH';
export const FETCH_CANCEL = 'app/data/FETCH_CANCEL';
export const FETCH_START = 'app/data/FETCH_START';
export const FETCH_SUCCESS = 'app/data/FETCH_SUCCESS';
export const FETCH_ERROR = 'app/data/FETCH_ERROR';
export const RESET_STATE = 'app/data/RESET_STATE';
